import { render } from "@/web/pages/doctores/EditDoctor.html?vue&type=template&id=b9e03c74&ts=true"
import script from "@/web/ts/controllers/doctor/editDoctor.ts?vue&type=script&lang=ts"
export * from "@/web/ts/controllers/doctor/editDoctor.ts?vue&type=script&lang=ts"

import "@/web/css/custom.css?vue&type=style&index=0&lang=css"

import exportComponent from "E:\\RESPALDO 17-01-26 PC\\git\\adminSanatorio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__